<template>
	<div>
		<p>
			{{
				selectRandom([
					"".concat(
						`Following methods are used for the analysis of data:  ${analysisOfData}`
					),
					"The data is analysed using the following methods: ".concat(
						`${analysisOfData}`
					)
				])
			}}
		</p>
		<p>
			{{
				selectRandom([
					"".concat(
						`Following factors are considered for collecting the data:  ${collectionOfData}`
					),
					"The data is collected by considering the following: ".concat(
						`${collectionOfData}`
					)
				])
			}}
		</p>
		<span>
			{{
				selectRandom([
					"".concat(
						`The results will be presented using the following approaches: ${resultsPresentation}`
					),
					`Following approaches will be used for the presentation of data: ${resultsPresentation}`
				])
			}}
		</span>
	</div>
</template>
<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputAnalysisOfData",
	mixins: [OutputMixin],
	computed: {
		analysisOfData: function() {
			return this.formatSelectMulti(this.$tera.project.ScopingWizard.dataAnalysis)
				.join(", ")
				.toLowerCase();
		},
		collectionOfData: function() {
			return this.formatSelectMulti(
				this.$tera.project.ScopingWizard.dataDescription
			)
				.join(", ")
				.toLowerCase();
		},
		resultsPresentation: function() {
			return this.formatSelectMulti(
				this.$tera.project.ScopingWizard.resultsPresentation
			)
				.join(", ")
				.toLowerCase();
		}
	}
};
</script>
<style scoped></style>
